var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-flex-1 tw-mr-2",attrs:{"icon":"time","theme":"info"}},[_vm._v(" "+_vm._s(_vm.deductionString)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }